export const orderBy = <T>(
	items: T[],
	property: keyof T,
	direction: 'asc' | 'desc' = 'asc',
): T[] => {
	if (items.length <= 1) {
		return items;
	}

	const firstValidItem: any = items.find((item: any) => {
		if (item[property] !== null && item[property] !== undefined) {
			return true;
		}

		return false;
	});

	const firstValidValue = firstValidItem?.[property];

	let compareFn: Function = () => 0;
	if (typeof firstValidValue === 'string') {
		if (direction === 'asc') {
			compareFn = (a: any, b: any) => {
				const aValue = ((a[property] ?? '') + '').toLocaleLowerCase();
				const bValue = ((b[property] ?? '') + '').toLocaleLowerCase();

				return aValue.localeCompare(bValue);
			};
		} else {
			compareFn = (a: any, b: any) => {
				const aValue = ((a[property] ?? '') + '').toLocaleLowerCase();
				const bValue = ((b[property] ?? '') + '').toLocaleLowerCase();

				return bValue.localeCompare(aValue);
			};
		}
	} else if (typeof firstValidValue === 'number') {
		if (direction === 'asc') {
			compareFn = (a: any, b: any) => a[property] - b[property];
		} else {
			compareFn = (a: any, b: any) => b[property] - a[property];
		}
	} else if (firstValidValue.isLuxonDateTime) {
		if (direction === 'asc') {
			compareFn = (a: any, b: any) => a[property].toMillis() - b[property].toMillis();
		} else {
			compareFn = (a: any, b: any) => b[property].toMillis() - a[property].toMillis();
		}
	}

	return items.slice().sort(compareFn as any);
};
